import BlankGift from '@components/blank/BlankGift';
import Column from '@components/Column';
import Filter from '@components/Filter';
import NewGiftFab from '@components/gift/NewGiftFab';
import styled from '@emotion/styled';
import useAppCustom from '@hooks/useAppCustom';
import { GiftBoxType } from '@models/gift';
import { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';

import GiftBoxChips from './components/GiftBoxChips';
import TransactionItem from './components/TransactionItem';
import useGiftBoxes from './hooks/useGiftBoxes';

function GiftBoxFragment() {
    const [type, setType] = useState<GiftBoxType>(GiftBoxType.RECEIVED);
    const [sort, setSort] = useState('CreatedAtDesc');
    const data = useGiftBoxes(type, sort);
    const { useExternalCouponInGift } = useAppCustom().coupon;
    const { t } = useTranslation('gift');
    return (
        <Fragment>
            <Column as='section' fullWidth>
                <GiftBoxChips type={type}
                    setType={setType} />
                <Filter title={t('giftBox.sortTitle')}
                    sort={sort}
                    setSort={setSort}
                    sortItems={[{ value: 'CreatedAtDesc', label: t('giftBox.sortOptions.createdAtDesc') },
                        { value: 'ExpiredAtAsc', label: t('giftBox.sortOptions.expiredAtAsc') }]}/>
                {data?.length === 0 && (
                    <BlankGift type={type === GiftBoxType.RECEIVED
                        ? 'RECEIVE' : 'SEND'} />
                )}
                <Contents>
                    {data?.map((giftBox) => (
                        <TransactionItem giftBox={giftBox}
                            key={giftBox.itemId} />
                    ))}
                </Contents>
            </Column>
            {useExternalCouponInGift && (
                <NewGiftFab/>
            )}
        </Fragment>
    );
}

const Contents = styled.article`
    display: grid;
    grid-gap: 24px;
    grid-template-columns: 1fr 1fr;
    padding: 32px 20px;
    width: 100%;
`;

export default GiftBoxFragment;
